import { useEffect } from "react";
import { zendesk } from "./zendesk";

/**
 * Keeps the Zendesk app iframe sized to its content, so the app never scrolls internally; the Zendesk sidebar
 * scrolls the app tray natively instead, avoiding nested scrollbars.
 */
export function useAutoResize(): void {
  useEffect(() => {
    const root = document.getElementById("root");
    if (!zendesk || !root) {
      return;
    }

    const observer = new ResizeObserver(entries => {
      const contentHeight = Math.ceil(entries[0].contentRect.height) + HEIGHT_BUFFER;
      const height = Math.max(contentHeight, MIN_HEIGHT);
      zendesk.invoke("resize", { width: "100%", height: `${height}px` });
    });
    observer.observe(root);

    return () => observer.disconnect();
  }, []);
}

/** Minimum app height, matching the compact logged-out state. */
const MIN_HEIGHT = 200;

/** Extra space accounting for child margins that collapse out of the measured root container. */
const HEIGHT_BUFFER = 24;
